import {
  FullWidthFeedIcon,
  FullWidthThinFeedIcon,
  ProductSizeFeedIcon
} from "assets/icons";
import cn from "classnames";
import { t } from "i18next";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { FormField } from "ui";

import { FeedInsertWidth, FeedInsertType } from "../../../../constants";
import { FeedInsertFormValues } from "../FeedInsertForm.types";

import styles from "../FeedInsertForm.module.scss";

const InsertFormField = () => {
  const { setValue, watch } = useFormContext<FeedInsertFormValues>();

  const insetType = watch("type");
  const form = watch("form");

  useEffect(() => {
    if (insetType !== FeedInsertType.SingleMedia) {
      setValue("form", FeedInsertWidth.FullWidth);
    }
  }, [insetType]);

  return (
    <FormField label={"Insert Form"}>
      <div className={styles.form_formOptionsContainer}>
        <button
          type="button"
          onClick={() => setValue("form", FeedInsertWidth.FullWidth)}
          className={cn(styles.form_formOption, {
            [styles.form_formOption_active]: form === FeedInsertWidth.FullWidth
          })}
        >
          <FullWidthFeedIcon />
          <span>{t("Full Width")}</span>
        </button>

        <button
          type="button"
          onClick={() => setValue("form", FeedInsertWidth.FullWidthThin)}
          disabled={insetType !== FeedInsertType.SingleMedia}
          className={cn(styles.form_formOption, {
            [styles.form_formOption_active]:
              form === FeedInsertWidth.FullWidthThin
          })}
        >
          <FullWidthThinFeedIcon />
          <span>{t("Full Width Thin")}</span>
        </button>

        <button
          type="button"
          onClick={() => setValue("form", FeedInsertWidth.ProductSize)}
          disabled={insetType !== FeedInsertType.SingleMedia}
          className={cn(styles.form_formOption, {
            [styles.form_formOption_active]:
              form === FeedInsertWidth.ProductSize
          })}
        >
          <ProductSizeFeedIcon />
          <span>{t("Product Size")}</span>
        </button>
      </div>
    </FormField>
  );
};

export default InsertFormField;
